module.exports = __webpack_public_path__ + "img/flag_hu.7f7407c0.png";